const config = require("settings/Configuration");

module.exports = function() {
    let lang = config.get("language");
    const deferred = $.Deferred();

    this.getLanguage = function() {
        return lang;
    };

    if (lang) {
        deferred.resolve();
    } else {
        console.log("call get");
        console.log($.get);
        $.get("/sslvpn_api/language")
            .done((response) => {
                console.log("done");
                lang = response;
            })
            .fail(() => {
                console.log("fail");
                lang = "en";
            })
            .always(() => {
                console.log("always");
                config.set("language", lang);
                deferred.resolve();
            });
    }

    return deferred.promise();
};